export default __webpack_public_path__ + "/dist/images/chef-icon.11c2081d9ca9ea95cb90f15d9211ca13.svg";